/**
 * 辅助函数：比较两个版本号。
 * @param {string} v1 - 版本号1
 * @param {string} v2 - 版本号2
 * @returns {number} 如果v1大于v2返回正数，相等返回0，小于返回负数
 */
export const compareVersion = (v1, v2) => {
  const s1 = v1.split('.')
  const s2 = v2.split('.')

  for (let i = 0; i < Math.max(s1.length, s2.length); i++) {
    let num1 = parseInt(s1[i] || '0', 10)
    let num2 = parseInt(s2[i] || '0', 10)

    if (num1 > num2) return 1
    if (num1 < num2) return -1
  }

  return 0
}
